<a [href]="googlePlayUrl" target="_blank">
  <img src="../../../../../assets/images/google-play-app.svg" class="h-12" alt="Get it on Google Play"/>
</a>
